import { useEffect, useState } from 'react'
import { AxiosResponse } from 'axios'
import pclnRequest from '@pcln/request'
import analytics from '@/shared-utils/analytics'
import config from 'isomorphic-config'
import { GraphQLResponse } from '@/types'
import SMS_DISCLAIMER_TEXT_INITIAL_VALUE from '@/constants/sms-disclaimer-text'
import { DisclaimerParams } from './useSmsDisclaimerQueryArgs'

export type Disclaimers = {
  optinStatus: unknown
  disclaimerText: {
    text: string
    url: string | null
  }[]
}

export type DisclaimersResponse = {
  smsDisclaimerTextByEmail: {
    disclaimers: [Disclaimers]
  }
  smsDisclaimerText: {
    disclaimers: [Disclaimers]
  }
}

const useGetDisclaimer = (baseParams: DisclaimerParams) => {
  const [disclaimers, setDisclaimers] = useState<Disclaimers[]>(
    SMS_DISCLAIMER_TEXT_INITIAL_VALUE
  )

  useEffect(() => {
    async function fetchSmsDisclaimer() {
      try {
        const { url, timeout } = config.client['pcln-graph']
        const response: AxiosResponse<GraphQLResponse<DisclaimersResponse>> =
          await pclnRequest({
            url,
            timeout,
            method: 'POST',
            data: {
              query: baseParams.query,
              variables: baseParams.disclaimerParams
            }
          })
        const { errors, data } = response.data
        if (Array.isArray(errors) && errors.length > 0) {
          const errorMessage =
            errors instanceof Error
              ? errors.message
              : ((errors as any).toString() as string)
          analytics.logError({
            message: `Failed to enroll for SMS subscription for cGuid: ${baseParams.clientGUID} Error message: ${errorMessage}`
          })
          return
        }
        if (data) {
          // TODO remove success log in seti cleanup. seti: HP_SMS_COMPONENT
          analytics.log({
            message: `Fetched disclaimer for cGuid: ${baseParams.clientGUID}`
          })
          setDisclaimers(
            data.smsDisclaimerTextByEmail?.disclaimers ||
              data.smsDisclaimerText?.disclaimers
          )
        }
      } catch (error) {
        const errorMessage =
          error instanceof Error
            ? error.message
            : ((error as any).toString() as string)
        analytics.logError({
          message: `Failed to query for SMS disclaimer text for cGuid: ${baseParams.clientGUID}. Error message: ${errorMessage}`
        })
      }
    }
    fetchSmsDisclaimer()
  }, [baseParams])

  return disclaimers
}

export default useGetDisclaimer
